import React from 'react';

const NotFound = () => {

  // NOTE: Datepicker 
  // 1. 
  return (
    <div className="main-content">
      <div className="text-xl mt-6">Page not found :-(</div>

    </div>

  )
};

export default NotFound;